import { create } from "zustand";
import { persist } from "zustand/middleware";

import { TransportType } from "../types/line";

type StationTransport = {
  stationId: number;
  transportType: TransportType;
};

export const useSavedStationTransports = create<{
  savedStationTransports: StationTransport[];
  addSavedStationTransport: (stationTransport: StationTransport) => void;
  removeSavedStationTransport: (stationTransport: StationTransport) => void;
}>()(
  persist(
    (set) => ({
      savedStationTransports: [],
      addSavedStationTransport: (stationTransport: StationTransport) =>
        set((state) => ({
          savedStationTransports: [
            ...state.savedStationTransports,
            stationTransport,
          ],
        })),
      removeSavedStationTransport: (stationTransport: StationTransport) =>
        set((state) => {
          const stationIndexToRemove = state.savedStationTransports.findIndex(
            (s) =>
              s.stationId === stationTransport.stationId &&
              s.transportType === stationTransport.transportType,
          );

          return {
            savedStationTransports: [
              ...state.savedStationTransports.slice(0, stationIndexToRemove),
              ...state.savedStationTransports.slice(stationIndexToRemove + 1),
            ],
          };
        }),
    }),
    { name: "saved-station-transports" },
  ),
);
